module.exports = __webpack_public_path__ + "static/src/content/images/processed/thumb/redzel.bae6144.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/thumb/redzel.jpg
// module id = RvCB
// module chunks = 0